<script>
    export let data;
</script>

{#if data.image}
    <img src={data.image} alt={data.imageAlt} />
{:else}
    <div class="header-text">{data.text}</div>
{/if}

<style>
    img {
        height: 100px;
        border-radius: 10px;
    }
</style>
